module.exports = __webpack_public_path__ + "static/media/xml-icon.ef003ad8.svg";